import axios from 'axios'

export const useCcrsService = () => {
  const app = useNuxtApp()
  const baseurl = useRuntimeConfig().public.CMS_URL || 'https://cms-dev.dev.fst.com'

  const strapi_axios = axios.create({
    baseURL: baseurl
  })

  async function getCcrsSearch(query, brands = []) {
    const endpoint = 'competitor-design-cross-references/search'

    if (query && query !== '') {
      let params = {query, region: app.$globalization.getRegion()}
      // brands is optional and is a array of Codes, e.g. ['F','D']
      if (Array.isArray(brands) && brands.length > 0) {
        params = {...params, brands: brands.join(',')}
      }
      const res = await strapi_axios.get(`/${endpoint}`, {params})
      if (res?.status >= 200 && res?.status <= 299) {
        return {items: res.data, query: query}
      }
    }
    return {items: [], query: null}
  }

  return {
    getCcrsSearch
  }
}
